<mat-card>
  <mat-card-content>

    <div fxLayout="row" fxLayoutAlign="space-between center" >

      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        
        <a routerLink="/products/catalog" [queryParams]="{ company: productCompany?.id }" routerLinkActive="active">
          <img class="product-company-logo" *ngIf="productCompany?.logoUrl" [lazyLoad]="productCompany?.logoUrl">
          <span class="product-company-name" *ngIf="!productCompany?.logoUrl && productCompany?.name">
            {{ productCompany?.name }}
          </span>
        </a>
        <div fxLayout="column" fxLayoutAlign="space-evenly start">
          <span class="product-name"> {{ product.name }} </span>
          <span class="product-sku"> {{ product.sku }} </span>
        </div>
      </div>
      
      <div *ngIf="!isAddMode && product.currentWorkflowState" fxLayout="row" fxLayoutAlign="end start" >
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px" class="current-state-div" [matTooltip]="product.currentWorkflowState.description">
          <product-workflow-icon
            [workflowStateType]="product.currentWorkflowState.stateType">
          </product-workflow-icon>

          <span class="current-state-name">
            {{ product.currentWorkflowState.name }}
          </span>
        </div>
        <div *ngIf="canAccessCurrentWorkflowState()" matRipple class="change-state-div" (click)="onOpenWorkflowDialog()" matTooltip="Open product transition dialog.">
          <mat-icon class="change-state-icon">alt_route</mat-icon>
        </div>
        <div *ngIf="!canAccessCurrentWorkflowState()" class="readonly-change-state-div">
        </div>
      </div>

    </div>
  
  </mat-card-content>
</mat-card>